export * from './detail-base.component';
export * from './detail-options.model';
export * from './detail.model';



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/ng-structures/detail/index.ts